package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.CardDemo

@Page
@Composable
fun CardPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/card.md", mapOf("title" to listOf("Card"), "description" to listOf("Displays a card with header, content, and footer.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import lucide_react.BellRing
import lucide_react.Check
import react.FC
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import shadcn.ui.components.*
import web.cssom.ClassName

data class Notification(
    val title: String,
    val description: String
)


 val notifications = listOf(
     Notification(
         title = "Your call has been confirmed.",
         description =  "1 hour ago",
     ),
     Notification(
         title = "You have a new message!",
         description =  "1 hour ago",
     ),
     Notification(
         title = "Your subscription is expiring soon!",
         description =  "2 hour ago",
     ),
 )
val CardDemo = FC<CardProps> {
    Card {
        className = ClassName("w-[380px]")
        CardHeader {
            CardTitle {
                +"Notifications"
            }
            CardDescription {
                +"You have 1 unread messages"
            }
        }
        CardContent {
            className = ClassName("grid gap-4")
            div {
                className = ClassName("flex items-center p-4 space-x-4 border rounded-md ")
                BellRing {}
                div {
                    className = ClassName("flex-1 space-y-1")
                    p {
                        className = ClassName("text-sm font-medium leading-none")
                        +"Push Notifications"
                    }
                    p {
                        className = ClassName("text-sm text-muted-foreground")
                        +"Send notifications to device."
                    }
                }

            }
            div {
                notifications.forEachIndexed { index, notification ->
                    div {
                        key = index.toString()
                        className = ClassName("mb-4 grid grid-cols-[25px_1fr] items-start pb-4 last:mb-0 last:pb-0")
                        span {
                            className = ClassName("flex w-2 h-2 translate-y-1 rounded-full bg-sky-500")
                        }
                        div {
                            className = ClassName("space-y-1")
                            p {
                                className = ClassName("text-sm font-medium leading-none")
                                +notification.title
                            }
                            p {
                                className = ClassName("text-sm text-muted-foreground")
                                +notification.description
                            }
                        }
                    }
                }

            }
        }
        CardFooter {
            Button {
                className = ClassName("w-full")
                Check {
                    className = ClassName("w-4 h-4 mr-2")
                }
                +"Mark all as read"
            }
        }
    }
}"""){ 
 CardDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Card
import shadcn.ui.components.CardHeader
import shadcn.ui.components.CardTitle
import shadcn.ui.components.CardDescription
import shadcn.ui.components.CardContent
import shadcn.ui.components.CardFooter
""", lang= "kotlin", highlight= "")
            CodeBlock("""Card {
    CardHeader {
        CardTitle { +"Card Title" }
        CardDescription { + "Card Description" }
    }
    CardContent { 
        p { + "Card Content" }
    }
    CardFooter {
        p { + "Card Footer" }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
